export const AUTH_CREDENTIALS = {
  username: 'medit_admin',
  password: 'MeditAdmin2024!',
};
